import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=db9e5da6&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=ts&"
export * from "./manage.vue?vue&type=script&lang=ts&"
import style0 from "./manage.vue?vue&type=style&index=0&id=db9e5da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9e5da6",
  null
  
)

export default component.exports